<template>
  <div class="custom-table__action">
    <mds-button
      size="small"
      variation="icon-only"
      icon="ellipsis-circle"
      type="button"
      :id="rowName"
      @click.native="handleClick"
    />

    <mds-popover
      size="small"
      class="custom-table__popover"
      v-model="toggle"
      :triggered-by="rowName"
      :position="['bottom-left']"
    >
      <mds-list-group class="custom-table__list">
        <mds-list-group-item
          text="Edit"
          class="custom-table__option"
          @click.native="triggerEvent('edit')"
        />
        <mds-list-group-item
          text="Delete"
          class="custom-table__option"
          @click.native="triggerEvent('delete')"
        />
      </mds-list-group>
    </mds-popover>
  </div>
</template>

<script>
import { MdsButton } from '@mds/button'
import MdsPopover from '@mds/popover'
import { MdsListGroup, MdsListGroupItem } from '@mds/list-group'
export default {
  components: {
    MdsButton,
    MdsPopover,
    MdsListGroup,
    MdsListGroupItem,
  },
  props: {
    rowId: {
      type: Number,
    },
    record: {
      type: Object,
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      toggle: false,
    }
  },
  computed: {
    rowName() {
      return `trigger-name-${this.rowId}`
    },
  },
  methods: {
    handleClick(event) {
      // This is to prevent the flyover opening when we click on the button that handles the popover
      event.stopPropagation()
      this.toggle = !this.toggle
    },
    triggerEvent(type) {
      this.$emit(type, this.record)
      this.toggle = false
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@mds/constants';

.custom-table {
  &__list {
    margin: $mds-space-half-x 0;
  }
  &__popover {
    width: 80px;
    padding: 0 !important;
  }

  &__option {
    cursor: pointer;
    padding: $mds-space-half-x $mds-space-1-x;

    &:hover {
      background: #e0ecf5;
    }
  }
}
</style>
